import { useNavigate } from "react-router-dom";
import { BATTLECARD_FLOW_NAV_STATE, BATTLECARD_PLAN_SELECTION_NAV_STATE } from "../../Utils/helpers";
import LegacyCheckPageLayout from "./legacy-check-page-layout";
import "./battle-cards.scss";

const CASH_BACK_COORDINATOR_EMAIL = "hello@stake.rent";

function BackArrowIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M6.5 2.75L1.25 8L6.5 13.25M1.75 8H14.25"
        stroke="#F4FDFA"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function LegacyRebateTerms() {
  const navigate = useNavigate();

  return (
    <LegacyCheckPageLayout>
      <div className="battle-cards-page bc-legacy-terms-page">
        <div className="bc-legacy-terms-card">
          <div className="bc-legacy-terms-header">
            <button
              type="button"
              className="bc-legacy-terms-back"
              aria-label="Back to plan options"
              onClick={() => navigate("/battlecard", { state: BATTLECARD_PLAN_SELECTION_NAV_STATE })}
            >
              <BackArrowIcon />
            </button>

            <div className="bc-legacy-terms-body">
              <h2 className="bc-legacy-terms-title">Your Cash Back is sent after your property pays.</h2>

              <p className="bc-legacy-terms-text">
                It is important to understand that Cash Back processing time depends primarily on
                the property where you leased. Upon move-in, we will send our referral invoice to
                your property. Only after this referral invoice has been paid can we process a
                customer&apos;s Cash Back. This process typically takes between 8 and 16 weeks, but
                can take longer depending on the property&apos;s invoice processing time.
              </p>

              <p className="bc-legacy-terms-contact">
                For an update on the status of your Cash Back, you may:
                <a
                  className="bc-legacy-terms-contact-link"
                  href={`mailto:${CASH_BACK_COORDINATOR_EMAIL}`}
                >
                  Contact a Cash Back Coordinator
                </a>
              </p>

              <div className="bc-legacy-terms-divider" />

              <div className="bc-legacy-terms-disclaimers">
                <p className="bc-legacy-terms-disclaimer">
                  Stake.rent&apos;s Cash Back offer is subject to all qualifications and conditions
                  outlined on our Disclaimers and Terms of Service page. Cash Back will only be sent
                  after your apartment community has paid Stake.rent&apos;s referral invoice. Cash
                  Back is typically mailed within 8 to 16 weeks after you move in, but can take
                  longer depending on your property&apos;s invoice processing time.
                </p>

                <p className="bc-legacy-terms-disclaimer">
                  All Cash Back customers must complete our Online Cash Back Request in order to
                  qualify. Cash Back requests must be submitted within 60 days of lease start date.
                  Cash Back will be paid via check and mailed to the address you provide during our
                  Online Cash Back Request process.
                </p>

                <p className="bc-legacy-terms-disclaimer">
                  In the event a Cash Back check is lost or stolen, you may request a replacement
                  check by contacting our Cash Back Department within 60 days of check issuance
                  date. Cash Back checks become void 60 days after date of issuance.
                </p>
              </div>
            </div>
          </div>

          <button
            type="button"
            className="bc-legacy-terms-cta"
            onClick={() => navigate("/battlecard/validate-address", { state: BATTLECARD_FLOW_NAV_STATE })}
          >
            Continue
          </button>
        </div>
      </div>
    </LegacyCheckPageLayout>
  );
}
